import { render, staticRenderFns } from "./relatorio-acessos.vue?vue&type=template&id=1a9ec31f&scoped=true&"
import script from "./relatorio-acessos.vue?vue&type=script&lang=js&"
export * from "./relatorio-acessos.vue?vue&type=script&lang=js&"
import style0 from "./relatorio-acessos.vue?vue&type=style&index=0&id=1a9ec31f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9ec31f",
  null
  
)

export default component.exports